import { createAnalyticsEvent } from '../create-analytics-event';
import { GAEventName } from '../ga-event-name.enum';

export const setUserLocation = createAnalyticsEvent<{
  location: {
    country: string;
    countryName: string;
    region: string;
    regionName: string;
    city: string;
    postalCode: string;
    latitude: string;
    longitude: string;
    timeZone: string;
  };
}>(({ location }) => ({
  event: GAEventName.USER_TRACKING_LOCATION,
  location
}));
